<template>
  <b-modal ref="formModal" :hideFooter="true" size="lg" title="Create new project" @hidden="onHide">
    <div class="row">
      <div class="col-12 m-form m-form--state">

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'name' }">
          <label for="name">Name</label>
          <input type="text" id="name" v-model="project.name" class="form-control" placeholder="Name">
        </div>

        <div class="form-group">
          <label for="po_number">PO Number</label>
          <input type="text" id="po_number" v-model="project.po_number" class="form-control" placeholder="PO Number">
        </div>

        <div class="text-center mt-3">
          <div class="btn btn-brand mr-1" @click="submit()">{{ isEdit ? 'Update' : 'Create' }}</div>
          <div class="btn btn-metal" @click="hide()">Cancel</div>
        </div>

      </div>
    </div>
  </b-modal>
</template>
<script>
  import bModal from 'bootstrap-vue/src/components/modal/modal'

  export default {
    components: {
      'b-modal': bModal,
    },
    created() {
      this.loadProject();
    },
    data() {
      return {
        project: {},
        errors: false,
        client: false,
      }
    },
    computed: {
      isEdit() {
        return this.project.id
      },
    },
    methods: {
      loadProject() {
        this.project = {
          id: null,
          name: null,
          client_id: null,
          po_number: null,
        }
      },
      onHide() {
        this.errors = false
        this.loadProject();
      },
      hide() {
        this.$refs.formModal.hide();
      },
      create(client) {
        this.project.client_id = client.id
        this.$refs.formModal.show();
      },
      edit(client, project) {
        this.project.client_id = client.id
        Object.assign(this.project, project)
        this.$refs.formModal.show();
      },
      submit() {
        if (this.isEdit) {
          this.update()
        } else {
          this.store()
        }
      },
      store() {
        this.axios.post('/projects', this.project).then(response => {
          if (response.data === 'EXISTS') {
            this.errors = {name: ['Project with this name already  exists and has fixed price.']};
          }
          if (response.status === 201) {
            this.$emit('projectCreated', response.data.data)
            this.$root.$emit('create-success', response.data.data)
            this.hide()
          }
        }).catch(err => {
          if (err.response.data && err.response.data.errors) {
            this.errors = err.response.data.errors
          }
        })
      },
      update() {
        this.axios.put('/projects/' + this.project.id, this.project).then(response => {
          if (response.status === 202) {
            this.$emit('projectUpdated', response.data.data)
            this.$root.$emit('update-success', response.data.data)
            this.hide()
          }
        }).catch(error => {})
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/clients/projects/ProjectForm.vue